import React, { Component } from 'react'

class Notification extends Component {
    constructor(props) {
        super(props);

        this.state = {}
    }

    render() {
        if (this.props.message.length > 0) {
            return (
                <div class={`alert alert-${this.props.type} alert-dismissible fade show`}>
                    <p class="mb-0" dangerouslySetInnerHTML={{ __html: this.props.message }} />

                    <button type="button" class="close" data-dismiss="alert" aria-label="Close" onClick={this.props.callback}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            )
        }
        return (
            <div></div>
        );
    }
}

export default Notification